import * as React from 'react'
import WeatherData from '../../images/ilustration_weather_data.svg'
import Globe from '../../images/ilustration_globe.svg'
import TargetPin from '../../images/ilustration_target_pin.svg'
import { StaticImage } from "gatsby-plugin-image"

export const SunHeronFeatures = ({featureTitle, featureBody, imageIlustrationType, offset=0} : {featureTitle: string, featureBody: string, offset?: number, imageIlustrationType: 'weather-data' | 'globe' | 'target_pin'}) => {
    let imgSrc = WeatherData
    if(imageIlustrationType === 'globe') imgSrc = Globe
    if(imageIlustrationType === 'target_pin') imgSrc = TargetPin
    return (<div className="col col--md--4 col--is--12">
        <div className="fp__features__feature__wrapper center">
            <div style={{ top: offset, position: 'relative' }} className="fp__features__image__wrapper">
                <img src={imgSrc} alt=""/>
            </div>
            <div className="h3">{featureTitle}</div>
            <p className="fp__features__feature__body">{featureBody}</p>
        </div>
    </div>)
}